import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'policy-kolton-pl',
    templateUrl: './policy-kolton-pl.component.html',
    styleUrls: ['./policy-kolton-pl.component.scss']
})
export class PolicyKoltonPlComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
